import { connect } from "react-redux";
import RankingsNav from "../RankingsNav.jsx";
import { fetchClassificationAction } from "../myResultsActions";
import { fetchSubleaguesListAction } from "../../Subleagues/subleaguesActions";

const mapStateToProps = (state) => {
  return {
    stages: state.classifications.stages,
    general: state.classifications.general,
    current: state.classifications.current,
    result: state.ranking.result,
    marked: state.markedSportsmen.sportsmen,
    game: state.games.current,
    strings: state.games.strings,
    hasOpenSubLeagues: state.games.hasOpenSubLeagues,
    hasSubLeagues: state.games.hasSubLeagues,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onClassificationClick: (classification) =>
      dispatch(fetchClassificationAction(classification)),
    onSubleagueClick: (type, game) =>
      dispatch(fetchSubleaguesListAction(type, game)),
  };
};

const RankingsContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(RankingsNav);

export default RankingsContainer;
